export const LIST_EXAM_WORD_TEST_CATEGORY = 'LIST_EXAM_WORD_TEST_CATEGORY';
export const CREATE_EXAM_WORD_TEST_CATEGORY = 'CREATE_EXAM_WORD_TEST_CATEGORY';
export const SHOW_EXAM_WORD_TEST_CATEGORY = 'SHOW_EXAM_WORD_TEST_CATEGORY';
export const UPDATE_EXAM_WORD_TEST_CATEGORY = 'UPDATE_EXAM_WORD_TEST_CATEGORY';
export const DELETE_EXAM_WORD_TEST_CATEGORY = 'DELETE_EXAM_WORD_TEST_CATEGORY';
export const EXAM_WORD_TEST_CATEGORY_ADD_DELETE = 'EXAM_WORD_TEST_CATEGORY_ADD_DELETE';
export const EXAM_WORD_TEST_CATEGORY_CHECK_ALL = 'EXAM_WORD_TEST_CATEGORY_CHECK_ALL';
export const EXAM_WORD_TEST_CATEGORY_PAGING = 'EXAM_WORD_TEST_CATEGORY_PAGING';
export const DATA_REMOVE_EXAM_WORD_TEST_CATEGORY = 'DATA_REMOVE_EXAM_WORD_TEST_CATEGORY';
